import moment from 'moment-timezone';
import DatePicker from "react-datepicker";
import React from "react";
export const customMoment = moment;

/**const iso8601RegExp = new RegExp("/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/");*/
const iso8601RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
const isIso8601DateRegExp = /^d{4}-d{2}-d{2}Td{2}:d{2}:d{2}(.d{3})?Z$/;
const isDateYYYYMMDDRegEx = /^\d{4}-\d{2}-\d{2}$/;


export const phonePattern = "[1-9]{1}[0-9]{2}[0-9]{3}[0-9]{3,5}";
export const phoneFullPattern = "[0-9]{1}[0-9]{2}[0-9]{3}[0-9]{3,5}";


export const toDateTimeUTC = (dt, hour, minute, gmt) => {
    if (typeof dt === 'object' && Number.isInteger(hour) && Number.isInteger(minute) && Number.isInteger(gmt)) {
        try {
            let date = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
            date.setHours(hour + (gmt * -1));
            date.setMinutes(minute);
            return date;
        } catch (e) {
            console.error(e.message, e);
        }
    }
    return null;
}

export const formatDateYMD = (datetime) => {
    if (datetime !== null && typeof datetime === 'object') {
        try {
            return moment(datetime).format('YYYY-MM-DD');
        } catch (e) {
            console.error(e.message, e);
        }
    }
    return null;
}

export const formatDatetimeMySQL = (datetime) => {
    if (datetime !== null && typeof datetime === 'object') {
        try {
            return moment(datetime).format('YYYY-MM-DD HH:mm:ss');
        } catch (e) {
            console.error(e.message, e);
        }
    }
    return null;
}

export const formatDateLocalString = (dt) => {
    try {
        return moment(dt).format('MMMM DD YYYY, HH:mm A');
    } catch (e) {
        console.error(e.message, e);
    }
    return '';
}

export const formatDatetimeISO = (datetime) => {
    if (datetime !== null && typeof datetime === 'object') {
        try {
            return moment(datetime).format('YYYY-MM-DD[T]HH:mm:ss');
        } catch (e) {
            console.error(e.message, e);
        }
    }
    return null;
}

export const formatDatetimeFriendly = (datetime) => {
    if (datetime !== null && typeof datetime === 'object') {
        try {
            return moment(datetime).format('YYYY-MM-DD hh:mm:ss A');
        } catch (e) {
            console.error(e.message, e);
        }
    }
    return null;
}


export const toDate = (str, format) => {
    if (format) {
        return moment(str, format).toDate();
    } else {
        return moment(str).toDate();
    }
}

export const isDateIso8601 = (str) => {
    return isIso8601Date(str);
}


export const isIso8601Date = (dateStr) => {
    if (dateStr && typeof dateStr === 'string') {
        return dateStr.match(isIso8601DateRegExp) != null;
    }
    return false;
}


export const isoString2Date = (isostring) => {
    if (isIso8601Date(isostring)) {
        return new Date(isostring);
    }
    return null;
}

export const toISODatetimeString = function (dateObject) {
    if (dateObject && typeof dateObject === 'object') {
        return dateObject.toISOString();
    }
    return null;
}

export function isDateYYYYMMDD(dateStr) {
    if (dateStr && typeof dateStr === 'string') {
        return dateStr.match(isDateYYYYMMDDRegEx) != null;
    }
    return false;
}

export function getDateYYYYMMDD(dateStr) {
    if (dateStr && dateStr.length >= 10) {
        return dateStr.substr(0, 10);
    }
    return null;
}


export const toLocaleString = (dateSource) => {
    if (typeof dateSource === 'string') {
        return toDate(dateSource).toLocaleString();
    }
    if (typeof dateSource === 'object') {
        return dateSource.toLocaleString();
    }
    return dateSource ? dateSource.toString() : '';
}


export const dateTime2String = (datetime) => {
    if (datetime !== null && typeof datetime === 'string') {
        return datetime;
    }

    if (datetime != null && typeof datetime === 'object') {
        return datetime.toLocaleDateString() + " " + datetime.toLocaleTimeString();
    }

    return '';
}

export const toLocalDateTimeString = (dateObj) => {
    if (dateObj != null && typeof dateObj === 'object') {
        return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();
    }
    return dateObj || '';
}



export const getLocalDateString = function (dateObj) {
    if (dateObj != null && typeof dateObj === 'object') {
        return dateObj.toLocaleDateString();
    }
    return dateObj || '';
}

export const getLocalTimeString = function (dateObj) {
    if (dateObj != null && typeof dateObj === 'object') {
        return moment(dateObj).format('hh:mm A');
    }
    return dateObj || '';
}


/**
 * Convert string datetime UTC+00 to locate Date
 * @param datetimeUTCstr Datetiem UTC+00
 * @returns Date locale
 */
export function reviveDateTimeJson(datetimeUTCstr, offset) {
    if (typeof datetimeUTCstr === 'string' && iso8601RegExp.test(datetimeUTCstr)) {
        try {
            if (offset) {
                return moment.utc(datetimeUTCstr).utcOffset(offset * 60, false).format('MM/DD/YYYY hh:mm A');
            } else {
                return moment.utc(datetimeUTCstr).toDate();
            }
        } catch (e) {
            console.error(e.message, e);
            return datetimeUTCstr;
        }
    } else {
        return datetimeUTCstr;
    }
}


// revive ISO 8601 date strings to instances of Date
export function reviveDateJson(valueDate) {
    let getDate = getDateYYYYMMDD(valueDate);
    if (typeof getDate === 'string' && isDateYYYYMMDDRegEx.test(getDate)) {
        return new Date(valueDate);
    } else {
        return valueDate;
    }
}


export const MyBirthDayPicker = (props) => {
    return (
        <DatePicker
            selected={props.selected}
            onChange={props.onChange}
            isClearable
            placeholderText="MM/DD/YYYY"
            dateFormat="MM/dd/yyyy"
        />
    )
}


export const MyDatePicker = (props) => {
    return (
        <DatePicker
            selected={props.selected}
            onChange={props.onChange}
            className={props.className}
            isClearable
            placeholderText="mm/dd/yyyy"
            dateFormat="MM/dd/yyyy"
        />
    )
}

export const MyDatetimePicker = (props) => {
    return (
        <DatePicker
            selected={props.selected}
            onChange={props.onChange}
            isClearable
            placeholderText="DD/MM/YYYY"
        />
    )
}
